import React from "react";
import FaqsList from "../faqsList/faqsList.jsx";
import styles from "./productDetails.scss";

const ProductDetails = ({ data }) => {
  if (!data) return null;
  return (
    <div className={styles["productDetails-container"]}>
      <FaqsList data={data} />
    </div>
  );
};

export default ProductDetails;
